module.exports = __webpack_public_path__ + "img/refuseApprovalIconUS.d657eb0c.png";